import React from 'react';
import { getSubCategoryId } from '../../../utils/DictionaryManagementUtils';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import SelectRecipientFP from '../FullPagesComponents/Services/Recipient/SelectRecipientFP';

//= ========================================================================

const RecipientsListDF = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { recipient } = globJSON.configurations.services[subCategoryId];

  return (
    <SimulatorsViewerArrangement
      simPlatform={simPlatform}
    >
      <SelectRecipientFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        headlineText={recipient.select_contact_title}
        withExpand
        slideshowRefs={slideshowRefs}
      />

    </SimulatorsViewerArrangement>
  );
};
export default RecipientsListDF;
